<div
  class="basic-dialog h-full flex flex-col justify-center"
>
  <div
    *ngIf="hideCloseBtn"
    class="close-icon-panel bg-palo-verde flex justify-center items-center"
  >
    <mat-icon (click)="closeDialog()"
              class="close-icon">close
    </mat-icon>
  </div>

  <div class="container-component max-h-[75vh] xs:h-[100vh] xs:max-h-[100vh]"
       mat-dialog-content>
    <template #anchor></template>
  </div>
</div>
